import axios from 'axios';

export const API_CONFIG = {
  // Dev-only: the Vite proxy (vite.config.js) adds the api-key header server-side.
  // Never put a FluxPrompt key here: everything in src/ ships to the browser.
  baseURL: '/api/flux',
  flowId: 'e57b99cc-b722-4967-8793-e6b6d0a6f424',
  timeout: 90000 // Reduce to 90 seconds since gateway times out around 1 minute
};

export const axiosInstance = axios.create({
  baseURL: API_CONFIG.baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: API_CONFIG.timeout,
  withCredentials: false
});

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const isTimeout = error.code === 'ECONNABORTED' || 
                     error.message.includes('timeout') ||
                     error.response?.status === 504;
                     
    if (isTimeout) {
      console.warn('API timeout - using fallback content');
      return Promise.resolve({ 
        data: { 
          success: true,
          output: error.config?.data?.variableInputs?.[0]?.inputText || '',
          fallback: true,
          error: 'The story generation service is currently experiencing high load. Using your original content as a fallback.'
        }
      });
    }
    return Promise.reject(error);
  }
);